import { render, staticRenderFns } from "./SmallFlightItinerary.vue?vue&type=template&id=e2f9e750&scoped=true&"
import script from "./SmallFlightItinerary.vue?vue&type=script&lang=js&"
export * from "./SmallFlightItinerary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f9e750",
  null
  
)

export default component.exports